import { render, staticRenderFns } from "./WhitelistList.vue?vue&type=template&id=2d8203da&scoped=true"
import script from "./WhitelistList.vue?vue&type=script&lang=js"
export * from "./WhitelistList.vue?vue&type=script&lang=js"
import style0 from "./WhitelistList.vue?vue&type=style&index=0&id=2d8203da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8203da",
  null
  
)

export default component.exports